import { Link } from "react-router-dom";

export const OrderClarificationModal = () => {
  return (
    <div
      className="modal fade"
      id="productfound"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex={-1}
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered modal-animate-center product-notfound-dialog">
        <div className="modal-content">
          <p className="order-status-close" data-bs-dismiss="modal">
            <i className="fa-regular fa-circle-xmark" />
          </p>
          <div className="modal-body p-0">
            <div className="product-found">
              <div className="product-found-title">
                <i className="fa-solid fa-triangle-exclamation" />
                <h4>ORDER CLARIFICATIONS</h4>
              </div>

              <div className="product-found-body">
                <p className="text-center">
                  Please review and clear any order clarifications. Once the
                  clarifications are resolved, you can proceed to checkout.
                </p>
                <div className="product-foundButton">
                  <div className="button-effect product-found-btn">
                    <Link
                      to="/OrderDetails"
                      className="btn btn-products btn-addcart"
                    >
                      <i className="fa-solid fa-check" /> Review Errors
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
